module.exports = __webpack_public_path__ + "static/media/t244.a8b7f50c.jpg";